import Informations from './informations'

export default Informations
